export const SCREENTABS_VALIDATION_ERROR = 'SCREENTABS_VALIDATION_FAILED';
export const FIELD_VALIDATION_ERROR = 'FIELD_VALIDATION_FAILED';
export const APPLY_CHANGES_FOR_UNREGISTERED_FIELD = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';

export const MULTIPLE_APPS_CONFLICT = 'MULTIPLE_APPS_CONFLICT' as const;
export const MULTIPLE_APPS_CONFLICT_CAUSE_FIELD = 'FIELD' as const;
export const MULTIPLE_APPS_CONFLICT_CAUSE_SCREENTABS = 'SCREENTABS' as const;
